
const state = {
  currentNe: {},
  neVisionList: {},
  resourceIdList: []
};

const getters = {
  currentNe: trackState => trackState.currentNe,
  neVisionList: trackState => trackState.neVisionList,
  resourceIdList: trackState => trackState.resourceIdList
};

const mutations = {
  newNe(trackState, newNe) {
    trackState.currentNe = newNe;
  },
  newNeVision(trackState, newNeVision) {
    trackState.neVisionList = newNeVision;
  },
  newResourceId(trackState, newResourceId) {
    trackState.resourceIdList = newResourceId;
  }
};

const actions = {
  setCurrentNe(context, newNe) {
    context.commit('newNe', newNe);
  },
  setNeVision(context, newNeVision) {
    context.commit('newNeVision', newNeVision);
  },
  setResourceId(context, newResourceId) {
    context.commit('newResourceId', newResourceId);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
